exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n.mce-menubtn.mce-fixed-width span{width:40px !important} \n.mce-tinymce.mce-container.mce-panel {position:relative !important; top:-40px !important}\n.mce-panel{background-color: transparent !important}\n.mce-btn {    background-color: transparent !important}\n.mce-floatpanel { background-color: white !important}\n\n.mce-ico, .mce-txt {\n    color: rgb(46, 109, 164) !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /app/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/app/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/app/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles